export const USER_ROLE_ADMIN = 'admin';
export const USER_ROLE_SELLER = 'seller';
export const USER_ROLE_SUPPLIER = 'supplier';
export const USER_ROLE_SUPER_ADMIN = 'super_admin';
